import React, { useContext, useEffect } from 'react'
import { authContext } from '../Login/AuthContext';
import "../conf.js"
import "./config.js"
import SelectAreas from './Benchmark/SelectAreas.js'
import BenchmarkTable from './Benchmark/BenchmarkTable.js'
import AsyncCSV from '../config/ExportCSV'
//import getZones, {Areas, getAreas} from "./config.js"

const Benchmark = () => {
  const { auth } = useContext(authContext);
  var headerBenchmark = [
    {label:"zone", key:"zone"},
    {label:"categorie", key:"categorie"},
    {label:"type", key:"type"},
    {label:"nbHotel2018", key:"nbHotel2018"},
    {label:"nbHotel2019", key:"nbHotel2019"},
    {label:"nbHotel2020", key:"nbHotel2020"},
    {label:"nbCheckin2018", key:"for2018"},
    {label:"nbCheckin2019", key:"for2019"},
    {label:"nbCheckin2020", key:"for2020"},
    {label:"nbNights2018", key:"for2018Nights"},
    {label:"nbNights2019", key:"for2019Nights"},
    {label:"nbNights2020", key:"for2020Nights"},
    {label:"EstimatedOverNights2018", key:"estimatedOverNights2018"},
    {label:"EstimatedOverNights2019", key:"estimatedOverNights2019"},
    {label:"EstimatedOverNights2020", key:"estimatedOverNights2020"},
  ];

  useEffect(() => {}, [auth.data])

  return (
      <div className="layout text">
        <h1 id="areas">Benchmark</h1>
        <SelectAreas/>
        <BenchmarkTable/>
        <div className="container">
          <AsyncCSV name={"Benchmark"} header={headerBenchmark} dataCSV="Ventilation"/>
        </div>
      </div>
  )
}

export default Benchmark;
